import {Component, computed, input, output} from "@angular/core";
import {ThemePalette} from "@angular/material/core";
import {FontAwesomeCode} from "@models";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {MatButton} from "@angular/material/button";
import {NgClass} from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {AnimatedMaterialIconComponent} from "@common/ui/animated-material-icon/animated-material-icon.component";

@Component({
	selector: "sim-button",
	templateUrl: "./sim-button.component.html",
	styleUrls: ["./sim-button.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	imports: [MatButton, NgClass, AnimatedMaterialIconComponent, MatIcon, TranslateModule],
	host: {
		"[class.disabled]": "disabled()",
	},
})
export class SimButton {
	// Inputs
	public label = input.required<string>();
	public icon = input.required<FontAwesomeCode>();
	public color = input<ThemePalette>("accent");
	public disabled = input<boolean>(false);
	public animation = input<{icon: FontAwesomeCode; trigger: boolean}>();
	public variant = input<"basic" | "raised" | "flat" | "stroked">("flat");
	public size = input<"small" | "large" | "x-large" | "xx-large">("large");

	// Output
	public onClick = output<void>();

	// Properties
	public isAnimated = computed(() => !!this.animation());

	protected buttonClicked(): void {
		if (!this.disabled()) {
			this.onClick.emit();
		}
	}
}
